<script setup lang="ts">
import type { TextFieldProps } from '@formwerk/core'
import { useFormContext, useTextField } from '@formwerk/core'

const props = defineProps<TextFieldProps>()

const { inputEl, inputProps, labelProps, errorMessage, errorMessageProps, fieldValue, isBlurred }
  = useTextField(props)

const form = useFormContext()

const isDirty = computed(() => fieldValue.value?.length > 0)
const errored = computed(() => (form ? form.isSubmitAttempted.value : isBlurred.value) && errorMessage.value)

useTextareaAutosize({ element: inputEl as unknown as Ref<HTMLTextAreaElement>, input: fieldValue })
</script>

<template>
  <div class="input">
    <div class="border-b border-current w-full relative" :class="{ 'c-red': errored }">
      <textarea
        v-bind="inputProps"
        rows="1"
        placeholder=" "
        class="peer typo-sans-1 c-current leading-5 pb-0.75 pt-3 appearance-none min-h-8.75 w-full block resize-none uppercase overflow-hidden"
      />

      <label
        v-bind="labelProps"
        class="typo-sans-1 leading-5 motion-snug pointer-events-none select-none uppercase left-0 top-3 absolute peer-focus:scale-80 peer-focus:-translate-x-10% peer-focus:-translate-y-4"
        :class="{
          '-translate-y-4 scale-80 -translate-x-10%': isDirty,
        }"
      >
        {{ label }}
      </label>
    </div>
    <TransitionDefault>
      <p
        v-if="errored"
        v-bind="errorMessageProps"
        class="text-red-500 typo-sans-1 mt-1"
      >
        {{ errorMessage }}
      </p>
    </TransitionDefault>
  </div>
</template>
